import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeWhile, finalize } from 'rxjs';

import { IQuery, QueryService } from '@app/core/queries';

@Component({
  selector: 'app-query-properties',
  templateUrl: './query-properties.component.html',
})
export class QueryPropertiesComponent implements OnDestroy {
  public form: FormGroup;
  public saving: boolean;

  private query: IQuery;
  private destroyed: boolean;

  constructor(
    cfg: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    private service: QueryService
  ) {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
    });

    if (cfg.data?.query) {
      this.query = cfg.data.query;
      this.form.patchValue(this.query);
    }
  }

  public saveChanges(): void {
    this.form.markAllAsTouched();

    Object.keys(this.form.controls).forEach((key) => {
      this.form.get(key).markAsDirty();
    });

    if (!this.form.valid) {
      return;
    }

    this.saving = true;

    this.service
      .createUpdateQuery({ id: this.query?.id, ...this.form.value })
      .pipe(
        takeWhile(() => !this.destroyed),
        finalize(() => (this.saving = false))
      )
      .subscribe((entity) => {
        this.dialogRef.close(entity);
      });
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }
}
